export const EMAIL_NOT_VERIFIED_STATE = 'email_not_verified';
export const NO_VALID_LICENSE_STATE = 'no_valid_license';
export const SUCCESS_STATE = 'success';
